var RuntimeTraitInfo = /** @class */ (function () {
    function RuntimeTraitInfo(name, kind, abc) {
        this.name = name;
        this.kind = kind;
        this.abc = abc;
        this.configurable = true; // Always true.
        this._type = undefined;
        this.typeName = null;
    }
    RuntimeTraitInfo.prototype.getType = function () {
        if (this._type !== undefined) {
            return this._type;
        }
        if (this.typeName === null) {
            return this._type = null;
        }
        var type = this.abc.applicationDomain.getClass(this.typeName);
        return this._type = (type && type.axCoerce) ? type : null;
    };
    return RuntimeTraitInfo;
}());
export { RuntimeTraitInfo };
